import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import AMLIcon from './AMLIcon/AMLIcon';

interface Props {
  isOpen: boolean;
  path?: string;
}

const StarsNavAdditionalIcon: React.FC<Props> = (props) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  return isAuthenticated ? <AMLIcon {...props} /> : null;
};

export default StarsNavAdditionalIcon;
